"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Theme = void 0;
require("./default.css");
var React = __importStar(require("react"));
var color_1 = __importDefault(require("./color"));
var Theme = /** @class */ (function (_super) {
    __extends(Theme, _super);
    function Theme() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.updateTheme = function () {
            var variables = _this.props.variables;
            if (variables) {
                Object.keys(variables).forEach(function (name) {
                    _this.root.style.setProperty("--".concat(name), variables[name]);
                });
            }
            var darkSuffix = "-alt-dark";
            var lightSuffix = "-alt-light";
            var alphaSuffix = "-alpha";
            var themeVariables = _this.themeVariables;
            if (!themeVariables) {
                return; // Can't fix this for Windows 8, but we can halt theme processing. #1188842149
            }
            Object.keys(themeVariables).forEach(function (name) {
                var existingValue = themeVariables[name];
                if (existingValue.indexOf("#") === 0) {
                    if (existingValue.length < 7) {
                        existingValue += existingValue.substr(1, 3);
                        existingValue = existingValue.substr(0, 7);
                    }
                    var color = color_1.default.fromHex(existingValue);
                    var unsuffixedName = name
                        .replace(darkSuffix, "")
                        .replace(lightSuffix, "")
                        .replace(alphaSuffix, "");
                    var altDarkPropertyName = "".concat(unsuffixedName).concat(darkSuffix);
                    var altDarkAlphaPropertyName = "".concat(unsuffixedName).concat(darkSuffix).concat(alphaSuffix);
                    var altLightPropertyName = "".concat(unsuffixedName).concat(lightSuffix);
                    var altLightAlphaPropertyName = "".concat(unsuffixedName).concat(lightSuffix).concat(alphaSuffix);
                    _this.root.style.setProperty(altDarkPropertyName, color.darken(10).asHsl());
                    _this.root.style.setProperty(altDarkAlphaPropertyName, color.darken(10).asHsla(0.6));
                    _this.root.style.setProperty(altLightPropertyName, color.lighten(10).asHsl());
                    _this.root.style.setProperty(altLightAlphaPropertyName, color.lighten(10).asHsla(0.08));
                }
            });
        };
        return _this;
    }
    Object.defineProperty(Theme.prototype, "root", {
        get: function () {
            return document.documentElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Theme.prototype, "css", {
        get: function () {
            return window.getComputedStyle(this.root);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Theme.prototype, "themeVariables", {
        get: function () {
            var variables = {};
            var styleSheets = document.styleSheets;
            var css = this.css;
            for (var i = 0; i < styleSheets.length; i++) {
                try {
                    var stylesheet = styleSheets[i];
                    for (var j = 0; j < stylesheet.cssRules.length; j++) {
                        try {
                            var rules = stylesheet.cssRules[j];
                            for (var k = 0; k < rules.style.length; k++) {
                                var name_1 = rules.style[k];
                                if (name_1 && name_1.startsWith("--")) {
                                    var value = css.getPropertyValue(name_1);
                                    if (value) {
                                        variables[name_1] = value.replace(" ", "");
                                    }
                                }
                            }
                        }
                        catch (error) { } // eslint-disable-line
                    }
                }
                catch (error) { } // eslint-disable-line
            }
            return variables;
        },
        enumerable: false,
        configurable: true
    });
    Theme.prototype.componentDidMount = function () {
        this.updateTheme();
    };
    Theme.prototype.componentDidUpdate = function () {
        this.updateTheme();
    };
    Theme.prototype.render = function () {
        return this.props.children;
    };
    return Theme;
}(React.Component));
exports.Theme = Theme;
exports.default = Theme;
//# sourceMappingURL=theme.js.map